import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12c0 5.163 3.965 9.444 9 9.95v-2.013C7.067 19.441 4 16.061 4 12c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3.34-2.075 6.22-5 7.413V17h-2v6h6v-2h-2.654C19.685 19.375 22 15.945 22 12c0-5.5-4.5-10-10-10S2 6.5 2 12z"
      fill="currentColor"
    />
    <path
      d="M16.6 12.9l-4.2 2L11 14V7h2v5.4l2.7-1.3.9 1.8z"
      fill="currentColor"
    />
  </svg>
);
